import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { useI18n } from "../../contexts/I18nContext";
import { Users, Smartphone, Sparkles, Crown, Receipt } from "lucide-react";

export default function AdminDashboard() {
  const { t } = useI18n();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, []);

  const cards = [
    { key: "total_users", icon: Users, label: t("admin_stat_users"), accent: "bg-zinc-900 text-white" },
    { key: "total_apps", icon: Smartphone, label: t("admin_stat_apps"), accent: "bg-white text-zinc-900" },
    { key: "pro_users", icon: Crown, label: t("admin_stat_pro"), accent: "bg-white text-zinc-900" },
    { key: "free_users", icon: Sparkles, label: t("admin_stat_free"), accent: "bg-white text-zinc-900" },
    { key: "total_invoices", icon: Receipt, label: t("admin_stat_invoices"), accent: "bg-white text-zinc-900" },
  ];

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} className={`surface-card p-5 ${c.accent.includes("zinc-900") && c.accent.includes("text-white") ? "!bg-zinc-900 !border-zinc-900 text-white" : ""}`} data-testid={`admin-stat-${c.key}`}>
              <div className="flex items-center gap-2 mb-3 opacity-80">
                <Icon className="w-4 h-4" strokeWidth={2} />
                <span className="text-xs font-medium uppercase tracking-wider">{c.label}</span>
              </div>
              <p className="font-display text-4xl font-bold tracking-tight">
                {stats == null ? "—" : (stats[c.key] ?? 0).toLocaleString()}
              </p>
            </div>
          );
        })}
        <div className="surface-card p-5">
          <div className="flex items-center gap-2 mb-3 opacity-80">
            <Receipt className="w-4 h-4" strokeWidth={2} />
            <span className="text-xs font-medium uppercase tracking-wider">{t("admin_stat_revenue")}</span>
          </div>
          <p className="font-display text-4xl font-bold tracking-tight">
            ${stats == null ? "—" : ((stats.revenue_cents || 0) / 100).toFixed(2)}
          </p>
          <p className="text-xs text-zinc-500 mt-1">{t("admin_stat_revenue_hint")}</p>
        </div>
      </div>
    </div>
  );
}
